import { useMemo } from 'react'
import { useAccessUser } from '@hook/useAccessUser'
import { TAB_SEARCH_INDEX_KEY, TAB_BROWSE_KEY } from './Collection/useCollectionViewModel'
import { getUserFullName } from '@utils'

import { Link } from 'react-router-dom'
import { MdLock, MdOutlineDelete, MdOutlineEdit } from 'react-icons/md'
import Checkbox from '$components/Forms/Checkbox'

export const CollectionsRow = ({
    userId,
    isParseAdmin,
    collection,
    setEditCollectionDialogOpen,
    setDeleteCollectionDialogOpen,
    setEditCollection,
    setDeleteCollection,
    hasChecked,
    toggleChecked,
    isDeletingCollections,
    // eslint-disable-next-line no-unused-vars
    showHideAssignToUser,
}) => {
    
    const editSpecificCollectionInfo = useAccessUser({
        accessType: 'additional',
        accessName: 'edit_a_specific_collection_info',
    })
    
    const deleteParseCollection = useAccessUser({
        accessType: 'collections',
        accessName: 'delete_parse_collection',
    })
    
    const deleteUserCollection = useAccessUser({
        accessType: 'collections',
        accessName: 'delete_user_uploaded_collection',
    })
    
    const canDeleteParseCollection = useMemo(() => (
        collection.isParse && deleteParseCollection
    ), [collection, deleteParseCollection])
    
    const canDeleteUserCollection = useMemo(() => (
        deleteParseCollection
            ? true
            : (collection.creatorId === userId /* && deleteUserCollection */) // @todo
    ), [userId, collection, deleteUserCollection])
    
    const canEditParseCollection = useMemo(() => (
        collection.isParse && deleteParseCollection
    ), [collection, deleteParseCollection])
    
    return (
        
        <tr className="CollectionsRow">
            
            <td className="w-[1rem] pl-1 pr-0">
                <Checkbox
                    checked={hasChecked(collection.id)}
                    disabled={isDeletingCollections}
                    onChange={() => toggleChecked(collection.id)}/>
            </td>
            
            <td className="align-middle col-2">
                <Link
                    data-testid="collections-row-name"
                    className="table-row"
                    to={`/collection/${collection.id}/${collection.isParse ? TAB_SEARCH_INDEX_KEY : TAB_BROWSE_KEY}`}>
                    {collection.name}
                </Link>
            </td>
            
            {collection?.documentsCount !== undefined && (
                <td className="align-middle col-2">
                    {collection.documentsCount.toLocaleString()}
                </td>
            )}
            
            {isParseAdmin && (
                <td className="hidden md:table-cell align-middle col-2">
                    {collection.isParse ? 'Parse Admins' : getUserFullName(collection.creator)}
                </td>
            )}
            
            
            <td className="hidden md:table-cell align-middle col-2">{collection.county}</td>
            <td className="hidden md:table-cell align-middle col-2">{collection.state}</td>
            
            <td className="text-right align-middle col-1">
                <div className="flex justify-center items-center gap-2">
                    {((collection.isParse && canEditParseCollection)
                        || (editSpecificCollectionInfo && !collection.isParse)) && (
                        <MdOutlineEdit
                            data-tooltip-id="default-tip"
                            data-tooltip-content="Edit"
                            className="text-lg cursor-pointer"
                            onClick={() => {
                                setEditCollection(collection)
                                setEditCollectionDialogOpen(true)
                            }}
                            data-test-id="CollectionRowEditButton"/>
                    )}
                    {(canDeleteParseCollection || canDeleteUserCollection) && (
                        collection.isLocked ? (
                            <MdLock
                                className="text-lg cursor-not-allowed"
                                title="This collection is locked from deletion"/>
                        ) : (
                            <MdOutlineDelete
                                data-tooltip-id="default-tip"
                                data-tooltip-content="Delete"
                                className="text-lg cursor-pointer"
                                onClick={() => {
                                    setDeleteCollection(collection)
                                    setDeleteCollectionDialogOpen(true)
                                }}
                                data-test-id="CollectionRowDeleteButton"/>
                        )
                    )}
                </div>
            </td>
        
        </tr>
        
    )
    
}
